import { LocalizedCurrency } from '@mews/framework';
import { GuestInHouseBalanceAndPreauthorizations } from '@mews-commander/data-access';
import { DividedList } from './DividedList';

export enum AmountType {
    Balance = 'balance',
    Preauthorizations = 'preauthorizations',
}

interface CompanionBalancePreauthorizationsListProps {
    companionIds: string[];
    balanceAndPreauth?: Record<string, GuestInHouseBalanceAndPreauthorizations>;
    amountType: AmountType;
}
export const CompanionBalancePreauthorizationsList = ({
    companionIds,
    balanceAndPreauth,
    amountType,
}: CompanionBalancePreauthorizationsListProps) => (
    <DividedList
        collectionIds={companionIds}
        renderItem={(id) => {
            const amount = balanceAndPreauth?.[id]?.[amountType];
            if (!amount) return null;
            return <LocalizedCurrency currency={amount.currency} value={amount.value} />;
        }}
    />
);
